import React from 'react';
import { motion } from 'framer-motion';
import { Lock, Download, Shield, ChevronRight } from 'lucide-react';
export function PricingCTA() {
  return <section id="pricing-section" className="py-24 bg-gradient-to-b from-[#1B2A4A] to-[#0F1D33] relative overflow-hidden" data-id="element-101">
      {/* Decorative background elements */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full max-w-4xl h-full opacity-10 pointer-events-none" data-id="element-102">
        <div className="absolute top-10 left-10 w-64 h-64 rounded-full border-2 border-[#C5A55A]" data-id="element-103" />
        <div className="absolute bottom-10 right-10 w-96 h-96 rounded-full border-2 border-[#C5A55A]" data-id="element-104" />
      </div>

      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10 text-center" data-id="element-105">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-106">
          <h2 className="text-4xl md:text-5xl font-bold text-[#C5A55A] mb-6 font-serif" data-id="element-107">
            No deje su futuro a la suerte.
          </h2>
          <p className="text-xl text-white/90 mb-12 max-w-2xl mx-auto" data-id="element-108">
            Asegure su tranquilidad hoy mismo por una fracción de lo que un
            asesor financiero le cobraría por una sola consulta.
          </p>

          <div className="bg-white/5 backdrop-blur-sm border border-[#C5A55A]/30 rounded-3xl p-8 md:p-12 max-w-2xl mx-auto shadow-2xl" data-id="element-109">
            <div className="mb-2" data-id="element-110">
              <span className="text-gray-400 line-through text-xl" data-id="element-111">
                Valor real: $197.00
              </span>
            </div>
            <div className="mb-8" data-id="element-112">
              <span className="text-white text-2xl mr-2" data-id="element-113">
                Precio Especial Hoy:
              </span>
              <span className="text-5xl md:text-7xl font-bold text-[#C5A55A] drop-shadow-lg" data-id="element-114">
                $27.00
              </span>
              <span className="text-white/70 text-xl ml-2" data-id="element-115">USD</span>
            </div>

            <motion.button whileHover={{
            scale: 1.03
          }} whileTap={{
            scale: 0.97
          }} onClick={() => window.open('https://tiendadelibrosdigital.com/cart/42545816797255:1', '_blank')} className="w-full flex items-center justify-center gap-2 bg-[#C5A55A] hover:bg-[#b39550] text-[#0F1D33] text-lg md:text-xl font-bold py-6 px-8 rounded-full shadow-[0_0_30px_rgba(197,165,90,0.5)] transition-all duration-300 mb-6 group" aria-label="Comprar ahora por 27 dólares" data-id="element-116">
              SÍ, QUIERO MAXIMIZAR MI SEGURO SOCIAL
              <ChevronRight className="w-6 h-6 group-hover:translate-x-1 transition-transform" data-id="element-117" />
            </motion.button>

            <p className="text-[#E8D5A3] text-sm md:text-base font-medium mb-8" data-id="element-118">
              Pago único. Sin suscripciones. Descarga inmediata en español.
            </p>

            {/* Trust Badges */}
            <div className="flex flex-col sm:flex-row justify-center items-center gap-6 sm:gap-10 border-t border-white/10 pt-8" data-id="element-119">
              <div className="flex items-center gap-2 text-white/70" data-id="element-120">
                <Lock className="w-5 h-5 text-[#22C55E]" data-id="element-121" />
                <span className="text-sm" data-id="element-122">Pago 100% Seguro</span>
              </div>
              <div className="flex items-center gap-2 text-white/70" data-id="element-123">
                <Download className="w-5 h-5 text-[#C5A55A]" data-id="element-124" />
                <span className="text-sm" data-id="element-125">Acceso Inmediato</span>
              </div>
              <div className="flex items-center gap-2 text-white/70" data-id="element-126">
                <Shield className="w-5 h-5 text-[#C5A55A]" data-id="element-127" />
                <span className="text-sm" data-id="element-128">Garantía de Satisfacción</span>
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}